import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import { FaqAnswer, FaqAnswerItem } from "../types";

interface FaqQuestionProps {
  question: string;
  answer: FaqAnswer;
  value: string;
}

export function FaqQuestion({ question, answer, value }: FaqQuestionProps) {
  const renderAnswer = () => {
    if (typeof answer === "string") {
      return <p className="text-sm text-muted-foreground">{answer}</p>;
    }

    return (
      <ul className="list-disc space-y-2 pl-5">
        {answer.map((item: FaqAnswerItem, index: number) => (
          <li key={index} className="text-sm text-muted-foreground">
            <span className={item.bold ? "font-bold" : ""}>
              {typeof item === "string" ? item : item.text}
            </span>
            {item.subItems && item.subItems.length > 0 && (
              <div className="mt-1 space-y-1 pl-4">
                {item.subItems.map((subItem, subIndex) => (
                  <p
                    key={subIndex}
                    className={`text-sm ${
                      subItem.bold
                        ? "font-bold text-foreground"
                        : "text-muted-foreground"
                    }`}
                  >
                    {typeof subItem === "string" ? subItem : subItem.text}
                  </p>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <AccordionItem value={value}>
      <AccordionTrigger className="text-left hover:no-underline">
        <h3 className="text-base font-semibold">{question}</h3>
      </AccordionTrigger>
      <AccordionContent className="pt-4">{renderAnswer()}</AccordionContent>
    </AccordionItem>
  );
}
